export default __webpack_public_path__ + "wait-icon.svg";